import { useQuery } from '@tanstack/react-query';
import movimientosService, {
  type FiltrosKardex,
} from '../services/movimientosService';

export const movimientosKeys = {
  all: ['movimientos-kardex'] as const,
  lista: (f: FiltrosKardex) => [...movimientosKeys.all, 'lista', f] as const,
};

/** Kardex global. `keepPreviousData` para que la tabla no parpadee al paginar. */
export const useKardex = (filtros: FiltrosKardex) =>
  useQuery({
    queryKey: movimientosKeys.lista(filtros),
    queryFn: () => movimientosService.listar(filtros),
    keepPreviousData: true,
    staleTime: 15 * 1000,
  });
